import { Component, OnInit } from '@angular/core';
import { CoreCustomPageReviewRenderer } from '../../shared/core-custom-page.decorator';
import { CoreReviewPageRendererBaseComponent } from '../../shared/core-review-page-renderer-base.component';

@CoreCustomPageReviewRenderer('standard-page-review-renderer')
@Component({
  selector: 'cu-standard-page-review-renderer',
  templateUrl: './standard-page-review-renderer.component.html',
  standalone: false
})
export class StandardPageReviewRendererComponent extends CoreReviewPageRendererBaseComponent implements OnInit {
  ngOnInit() {}
}
